export const DEFAULT_RECORDING_RESTART_INTERVAL = 1000 * 60 * 4 // 4 minutes - Google Speech to Text has a limit of 5 minutes
export const DEFAULT_AUDIO_RECORDING_INTERVAL = 1000 * 3 // 3 seconds
export const DEFAULT_SEND_AUDIO_ATTEMPTS = 3
export const DEFAULT_SEND_AUDIO_RETRY_DELAY = 200
